import React from "react";

import JournalIcon from "../../../common/icons/timeslots/JournalIcon";
import HiddenIcon from "../../../common/icons/integrations/HiddenIcon";
import MoreIcon from "../../../common/icons/timeslots/MoreIcon";
import AppTheme from "../../../AppTheme";
import MoodColors from "../../../common/mood/MoodColors";
import CloseIcon from "../../../common/dialog/CloseIcon";

const snoozeOptions = [
  {
    name: "Write Journal",
    icon: (
      <JournalIcon
        style={{ width: 16, height: 16 }}
        fillColor={AppTheme.almostBlack}
      />
    ),
  },
  /* {
    name: "More Details",
    icon: <MoreIcon width={16} height={16} color={AppTheme.almostBlack} />,
  }, */
  {
    name: "Hide Comparison",
    style: { color: MoodColors.VeryBad },
    icon: (
      <HiddenIcon
        width={16}
        height={16}
        color={MoodColors.VeryBad}
        color2={MoodColors.VeryBad}
      />
    ),
  },
  {
    name: "Cancel",
    icon: (
      <CloseIcon
        color={AppTheme.almostBlack}
        opacity={1}
        style={{ position: "relative", top: "unset", right: "unset" }}
      />
    ),
  },
];

// ------------------------------------- API -------------------------------------
const getComparisonCardData = (
  controller,
  selectedDate,
  noGoal = false,
  data = {},
) => {
  const activities = {};
  (controller.state?.elements || []).forEach((a) => (activities[a.id] = a));

  const element = data.id_element ? activities[data.id_element] : null;
  if (!element) return;

  const reflectionHours = data.reflection_hours;
  if (reflectionHours) {
    Object.keys(reflectionHours).forEach((k) => (reflectionHours[k].date = k));
  }

  const output = {
    id: data.id_element,
    element,
    selectedDate,
    hours: data.hours,
    averages: data.averages,
    goal: noGoal ? null : data.goal,
    reflection_hours: reflectionHours,
    interval: data.interval
  };

  return output;
};

const markAsSelected = (controller, id, selected, refreshHandler) => {
  const action = {
    action: "save",
    target: "comparison_view_entry",
    id,
    selected,
    view: "Default",
  };

  controller.cardActionWithCallback(action, refreshHandler);
};

const ComparisonHelper = {
  snoozeOptions,
  markAsSelected,
  getComparisonCardData,
};

export default ComparisonHelper;
